<form #host [hidden]="hidden()" [class.open]="open()" autocomplete="off" >
    <input #input
        [id]="inputId()"
        [name]="inputId()"
        [ngClass]="inputId()"
        type="text"
        [(ngModel)]="filterExpression"
        [placeholder]="placeholder()"
        [required]="required()"
        [disabled]="disabled()"
        (keydown.tab)="enter()"
        (keydown.enter)="enter()" />
    <div class="list-container down"
        [ngStyle]="{ 'max-height': dropDownMaxHeight() + 'px', 'width': dropDownWidth() + 'px', visibility: visibility() }">
        <ul>
            <li *ngFor="let element of filteredElements()"
                #filteredDOMElement tabindex="-1"
                (click)="select(element, $event)"
                (keydown)="onKeydown($event, element)">
                    <ng-container *ngTemplateOutlet="dropdownElementTemplate(); context: { $implicit: element.display, searchables: element.searchables }"></ng-container>
            </li>
        </ul>
    </div>
</form>
